<template>
  <div id="navbarmenu">
    <b-navbar class="navbaredit">
      <template #brand>
        <b-navbar-item id="logonavbar" to="/" tag="router-link">
          <p class="tw-text-teal-700 tw-text-3xl tw-font-bold tw-px-1">dtt.travel</p>
        </b-navbar-item>
      </template>
      <template #start>
        <span v-if="user.role.id == 1">
          <dtt-admin-navbar-component :magicNav="magicNav" />
        </span>
        <div class="customNavbar" v-else>
          <template v-for="(navModule, key) in magicNav">
            <b-navbar-item
              v-if="navModule && navModule.name"
              :to="navModule.uri"
              tag="router-link"
              exact
              :key="key"
              :id="navModule.name.replace(' ', '')"
              v-show="enableHotelRates(navModule.name)"
            >
              {{ $t(`lang.navbar.${navModule.name}`) }}
            </b-navbar-item>
            <b-navbar-dropdown v-else :label="$t(`lang.navbar.${key}`)" boxed animation="fade">
              <b-navbar-item
                v-for="(module, key) in navModule"
                :to="module.uri"
                tag="router-link"
                :key="key"
                :id="module.name.replace(' ', '')"
              >
                {{ $t(`lang.navbar.${module.name}`) }}
              </b-navbar-item>
            </b-navbar-dropdown>
          </template>
        </div>
      </template>
      <template #end>
        <b-dropdown aria-role="list" class="dropdownitemcustom" :mobile-modal="false">
          <template #trigger="{ active }">
            <div class="tw-flex">
              <p class="control tw-pb-4 md:tw-pb-0">
                <a class="tw-border tw-border-teal-700 tw-rounded-md tw-px-6 tw-py-1.5 tw-text-teal-700 hover:tw-bg-teal-700 hover:tw-text-white tw-transition-all tw-duration-300">
                  <b-icon icon="user" pack="fas" />
                  &nbsp; {{ user.first_name }} {{ user.last_name }}
                </a>
              </p>
            </div>
          </template>
          <b-dropdown-item class="bordermenu" @click="isImageModalActive = true">
            <div class="tw-flex tw-justify-center tw-items-center tw-gap-2">
              <b-icon icon="earth" />
              <span>{{ selectedLang == "en" ? "English" : "Español" }}</span>
            </div>
          </b-dropdown-item>
          <b-dropdown-item class="bordermenu">
            <div class="content has-text-left contentnavbar">
              <b-button
                href="/login"
                :class="isLoadingLogout ? 'is-loading' : ''"
                class="!tw-w-full !tw-text-sm !tw-text-teal-700 !tw-border-transparent !tw-bg-transparent hover:!tw-border-teal-700 hover:!tw-bg-transparent active:!tw-bg-teal-100 tw-transition-all !tw-border focus:!tw-outline-none focus:!tw-ring-0 tw-rounded-md"
                @click.prevent="handleLogout()"
                icon-left="logout"
              >
                Logout
              </b-button>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-navbar>
    <b-modal :active.sync="isImageModalActive" has-modal-card trap-focus aria-modal>
      <template #default="props">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ $t('lang.navbar.selectlanguage') }}</p>
          </header>
          <section class="modal-card-body">
            <div class="buttonbox" v-for="(lang, i) in langs" :key="`lang-${i}`" aria-role="listitem" @click="isImageModalActive = false">
              <b-button
                :type="selectedLang == lang ? '!tw-w-full !tw-text-sm !tw-text-teal-700 !tw-border-teal-700 hover:!tw-bg-teal-50  active:!tw-bg-teal-100 tw-transition-all !tw-border focus:!tw-outline-none focus:!tw-ring-0 tw-rounded-md' : 
                '!tw-w-full !tw-text-sm !tw-text-gray-500 !tw-border-gray-500 hover:!tw-bg-teal-50  active:!tw-bg-teal-100 tw-transition-all !tw-border focus:!tw-outline-none focus:!tw-ring-0 tw-rounded-md'"
                icon-left=""
                @click="$i18n.locale = lang"
              >
                {{ lang == "en" ? "English" : "Español" }}
              </b-button>
            </div>
          </section>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import DttAdminNavbarComponent from '@/components/DttAdminNavbarComponent';

export default {
  name: "navbar-menu",
  components:{
    DttAdminNavbarComponent
  },
  data() {
    return {
      isLoadingLogout: false,
      isBurgerActive: false,
      langs: ['en', 'es'],
      isImageModalActive: false,
      userRole: null,
      dttHotel: false,
      dropdownItemsVisibility: false
    };
  },
  computed: {
    ...mapGetters("auth", ["user", "magicNav"]),
    selectedLang(){
      return this.$i18n.locale
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === '/bookings' && to.query.withoutConfirmation === 'true') return;
      if (Object.keys(to.query).length > 0) {
        this.$router.replace({ path: to.path }).catch(err => {});
      }
      if (this.user.role.id != 1) {
        var uris = [] 
        Object.values(this.magicNav).map(option=> {
          if (option.uri) {
            uris.push(option.uri)
          }
          else {
            Object.values(option).map(suboption=> {
              uris.push(suboption.uri)
            })
          }
        });
        this.$nextTick(() => {
          const isAllowed = uris.some(uri => uri === to.path);
          if(from.path === '/notallowed' && isAllowed || to.path == '/login') {
            this.$router.replace('/').catch(err=>{console.log(err)})
          }
          if(!isAllowed && (from.path != '/availability' && to.path != '/')) {
            if (to.path !='/login') {
              this.$router.push('/notallowed').catch(err=>{console.log(err)})
            } else {
              this.$router.push('/').catch(err=>{console.log(err)})
            }
            }
          })
        // if (uris.findIndex(uri => uri == to.path) < 0 ){
        //   this.$router.push('/notallowed').catch(err=>{})
        // }
      }
    },
    selectedLang(nv, ov) {
      this.updateLocale(nv);
      this.$store.commit('global/updateLocale', nv.toLowerCase());
      window.localStorage.setItem('locale', nv.toLowerCase());
    }
  },
  mounted(){
    this.updateLocale(this.$i18n.locale);
    if (this.user.role.name == 'Hotel') {
      this.userRole = this.user.role.name;
      this.dttHotel = this.user.clients.operators[0].name == 'DTT' ? true :  false;
    }
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    ...mapActions("global", ["updateLocale"]),
    handleLogout: function() {
      return this.$store
        .dispatch("global/setDialogNotification", {
          title: this.$t('lang.home.logoutTitle'),
          text: this.$t('lang.home.logoutText'),
          type: "danger"
        })
        .then(result => {
          this.logout();
        })
        .catch(e => {});
      this.isLoadingLogout = true;
    },
    enableHotelRates(module) {
      const extraModules = ['Rates', 'Rate Plans'];
      if (extraModules.includes(module)) {
        if (this.userRole == 'Hotel') {
            return true;
        }
      }
      return true;
    }
  }
};
</script>
<style>
#navbarmenu {
  .navbar-end {
    align-items: center;
    padding: 0 12px;
  }

  .dropdownitemcustom {
    .dropdown-content {
      width: 150px;
      padding: 0;
    }
  }

  .bordermenu {
    border-bottom: 1px solid rgba(#000, .03);
    padding: 12px;
    font-size: .9rem;
  }

  .contentnavbar {
    align-items: center;
    display: flex;
    justify-content: left;
  }

  .modal-card-body {
    display: flex;
    justify-content: space-around;
  }

  .modal-card-head {
    background-color: #0f766e;

    .modal-card-title {
      color: #fff;
    }
  }
}

#logonavbar {
  background-color: transparent !important;
  color: none !important;
  border: none;
  box-shadow: none;
}

.navbar-brand .navbar-item img {
  width: 145px;
  margin: auto;
}

a {
  border-bottom: 2px solid transparent;
}

a.is-active {
  color: #0f766e !important;
   /* box-shadow: 0px 6px 0px -4px #0f766e; */
  border-bottom: #0f766e 2px solid;
}

a.is-active:hover {
  background-color: #0f766e !important;
  color: white !important;
  /* box-shadow: 0px 6px 0px -4px #0f766e; */
  border-bottom: #0f766e 2px solid;
}

a.navbar-item.navbar-img.is-active {
  background-color: white !important;
}

.margin-navbar-menu {
  margin-right: inherit !important;
}

@media screen and (max-width: 1023px) {
  .navbaredit {
    .navbar-menu {
      position: absolute;
      z-index: 1;
      width: 100%;
    }
  }
}

@media (max-width: 768px) {
  .navbar-start {
    margin-bottom: 20px;
  }
}

a.navbar-item:hover, a.navbar-link:hover {
  color: #0f766e;
  transition: all 0.2s ease-in-out;
  /* box-shadow: 0px 6px 0px -4px #0f766e; */
  border-bottom: #0f766e 2px solid;
}

.navbar-link:not(.is-arrowless)::after {
  border-color: #0f766e;
}

@media screen and (min-width: 1024px) {
  .navbar-dropdown a.navbar-item:focus,
  .navbar-dropdown a.navbar-item:hover {
    color: white;
    background-color: #0f766e;
    transition: all 0.05s ease-in-out;
  }
}

.customNavbar {
  display: flex;
}

.customNavbar > .navbar-item {
  height: 48px;
}

@media (max-width: 1023px) {
  .customNavbar {
    flex-direction: column;
  }

  .navbar .navbar-dropdown.is-boxed {
    background-color: #fff !important;
    z-index: 9999;
    position: relative;
    box-shadow: 0px 5px #d4d4d485;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/NavbarMenu.vue